import { render, staticRenderFns } from "./FormProSetting.vue?vue&type=template&id=dbb77848&scoped=true"
import script from "./FormProSetting.vue?vue&type=script&lang=js"
export * from "./FormProSetting.vue?vue&type=script&lang=js"
import style0 from "./FormProSetting.vue?vue&type=style&index=0&id=dbb77848&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbb77848",
  null
  
)

export default component.exports